// Display-only phone masking. Every screen shows lead/patient numbers masked
// (all roles, super admin included); the full number is revealed only through
// the audited "View" action on the lead detail page (POST /leads/:id/phone-view).
// Exports, search and tel:/wa.me hrefs keep using the raw value — this is purely
// what's painted on screen.
//
// MUST stay byte-for-byte identical to the Flutter app's maskPhone:
//   - only the first number is used when the field holds several (, ; / & or "ext")
//   - strip non-digits, then a leading "00" international prefix
//   - Indian forms (12 digits "91…", 11 digits "0…") → the 10-digit national
//     number, NO country prefix
//   - < 5 digits → all X
//   - otherwise first 2 + last 2 visible, the rest X
//
//   "+91 98765 43210" / "919876543210" / "09876543210" / "9876543210" → "98XXXXXX10"
//   "+971501234567" → "97XXXXXXXX67"
//   null / "" → ""
// Same separator set as the app's `_tail` (core/phone.dart).
const TAIL = /[,;/&\n]|\s+(?:or|ext|extn|x)\b/i;

export function maskPhone(value) {
  let raw = value == null ? "" : String(value).trim();
  if (!raw) return "";
  const cut = raw.search(TAIL);
  if (cut > 0) raw = raw.slice(0, cut).trim();
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length === 12 && digits.startsWith("91")) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  if (!digits) return "";
  if (digits.length < 5) return "X".repeat(digits.length);
  return digits.slice(0, 2) + "X".repeat(digits.length - 4) + digits.slice(-2);
}

// alt_mobile can be a list (patients) or a string (leads); mask each entry.
export function maskPhoneList(value) {
  if (Array.isArray(value)) return value.filter(Boolean).map(maskPhone).join(", ");
  return maskPhone(value);
}

// For labels that may be a name OR a bare number (e.g. a WhatsApp chat with no
// lead linked falls back to the phone as its name) — masks only the number case.
export function maskIfPhone(text) {
  if (text == null) return text;
  return /^\+?[\d\s()-]{7,}$/.test(String(text).trim()) ? maskPhone(text) : text;
}
